import Utils from './Utils.js';
import Common from './Common.js';

const singleton = Symbol();
const singletonEnforcer = Symbol();

class MouseWheel {

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw "Cannot construct singleton"
        }
        this.comm = Common.instance;
        this.callbackFnList = [];
    }

    static get instance() {
        if(!this[singleton]) {
            this[singleton] = new MouseWheel(singletonEnforcer);
        }
        return this[singleton];
    }

    /** 마우스휠 이벤트 방향 감지 */
    getWheelDirection(e){
        if(e.type == "DOMMouseScroll") return e.originalEvent.detail > 0 ? 1 : -1;
        if(e.originalEvent.wheelDeltaY) return e.originalEvent.wheelDeltaY > 0 ? -1 : 1;
        return e.originalEvent.wheelDelta > 0 ? -1 : 1;
    }

    MouseWheelHandler(ev){
        let e = window.event || ev;
        let d = this.wheelDistance(e);
        let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));

        let re = true;

        if (delta <= -1 && d < -0.7) {
            re = false;
        } else if ( delta >= 1 && d > 0.7 ) {
            re = false;
        }
        return re;
    }

    wheelDistance (evt){
        if (!evt) evt = event;
        let w = evt.wheelDelta;
        let d = evt.detail;
        if (d){
            if (w) {
                return w/d/40*d>0?1:-1; // Opera
            } else {
                return -d/3; // Firefox;
            }
        } else return w/120; // IE/Safari/Chrome
    }

    addCallback(_fn){
        this.callbackFnList.push(_fn);
    }

    init(){
        this.comm.mainContainer.on( 'mousewheel.fs DOMMouseScroll.fs', (ev) =>{
            ev.preventDefault();
            if(!this.comm.option.useMouseWheel) return false;

            if(Utils.isPreventTime(this.lastWheelTime, this.comm.option.transitionDuration+100)) return;
            if(this.MouseWheelHandler(ev)) return;

            this.lastWheelTime = new Date().getTime();
            const dir = this.getWheelDirection(ev);

            this.callbackFnList.forEach( _fn => _fn(dir) );
        } );
    }

    stop(){
        this.comm.mainContainer.off('mousewheel.fs DOMMouseScroll.fs');
    }
}

export default MouseWheel;


// WEBPACK FOOTER //
// ./MouseWheel.js